module.exports = __webpack_public_path__ + "media/public/img/tripadvisor-round-01-385d03172616b1a1306be21ef117dde3.svg";